import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { DeviceFrame } from '../DeviceFrame';
import { SnakExperience } from '../experience/SnakExperience';
import type { Format } from '../../types/presentation';
interface PlayOverlayProps {
  format: Format;
  onClose: () => void;
  onOpenStrategy: () => void;
  onOpenJourney: () => void;
  onOpenStoryboard: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;

/** The Snak exactly as a specialist meets it — no presentation shell. */
export function PlayOverlay({
  format,
  onClose,
  onOpenStrategy,
  onOpenJourney,
  onOpenStoryboard
}: PlayOverlayProps) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = previous;
      window.removeEventListener('keydown', onKey);
    };
  }, [onClose]);
  const experience = <SnakExperience onOpenStrategy={onOpenStrategy} onOpenJourney={onOpenJourney} onOpenStoryboard={onOpenStoryboard} data-id="element-476" data-mp="2xiqs2m1y81c5" />;
  return <motion.div role="dialog" aria-modal="true" aria-label="The DME phenotyping Snak" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.25,
    ease: EASE
  }} className="no-print fixed inset-0 z-40 flex items-center justify-center bg-[#061524]" data-id="element-477" data-mp="379leprj3x2y4">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98,
      y: 14
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.05,
      ease: EASE
    }} className={format === 'mobile' ? 'flex h-full items-center justify-center py-6' : 'flex h-full w-full max-w-[440px] flex-col'} data-id="element-478" data-mp="29ph6djejtzyx">
        {format === 'mobile' ? <DeviceFrame label="The DME phenotyping Snak" sizeClassName="h-[clamp(500px,calc(100vh-56px),900px)] w-auto aspect-[344/688]" data-id="element-479" data-mp="2rpjzx2sp2kfy">
            {experience}
          </DeviceFrame> : experience}
      </motion.div>

      <button type="button" onClick={onClose} aria-label="Close the prototype" className="fixed right-5 top-5 z-10 inline-flex h-10 w-10 items-center justify-center rounded-full bg-paper/10 text-paper/70 transition-colors duration-150 hover:bg-paper/20 hover:text-paper focus:outline-none focus-visible:ring-2 focus-visible:ring-mint" data-id="element-480" data-mp="31lwsfxci6s94">
        <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-481" data-mp="2hy75c3fihg68" />
      </button>
    </motion.div>;
}